import { action, observable, runInAction } from 'mobx'
import { message, Modal } from 'hljd'
import BaseStore from '@store/table'
import Api from '@api/xiu_yan/liteAppManageApi'
import liteAppApi from '@api/yun_xuan/liteAppApi'
import { OLD_LITEAPP, SHOP_PRODUCTS_PATH } from '@constant'
import { getSessionMerchantInfo } from '@merchant-backend/util'
import { hashHistory } from 'react-router'

const confirm = Modal.confirm

class Store extends BaseStore {
  @observable statusAuthorize = 0
  @observable failVisible = false
  @observable visibleTips = false

  @action
  cancel = type => () => {
    this[type] = false
  }

  @action
  getAuth = async () => {
    let return_url = window.location.href.split('#')
    let newTab = window.open('about:blank')
    let {
      data: { url },
      success
    } = await liteAppApi.getAuthUrlApi({
      redirect_uri: escape(return_url[0] + '#/localMerchant/liteApp/manage')
    })
    if (success) {
      this.visibleTips = true
      this.failVisible = false
      newTab.location.href = url
    }
  }

  @action
  doneAuth = async () => {
    let {
      data: { auth_status },
      success
    } = await liteAppApi.getAuthStatusApi({
      merchant_id: getSessionMerchantInfo().id
    })
    if (!success) return
    if (+auth_status === 1) {
      this.visibleTips = false
      return message.success('授权小程序成功')
    } else {
      this.visible = false
      return message.error('授权小程序失败')
    }
  }

  $listApi = Api.list
  @observable total = 0
  @observable list = []
  $extraOp = data => {
    this.total = data.total_count || 0
    this.list = data.list || []
  }

  @action
  del = (id, nick_name) => () => {
    confirm({
      title: '确认删除' + nick_name + '？',
      content: '删除成功后，此员工将不能使用商家小程序的快速分享等功能',
      onOk: async () => {
        let { success } = await Api.unbind({ id })
        if (success) {
          message.success('操作成功！')
          this.$getList()
        }
      }
    })
  }

  @observable visible = false
  @action
  add = () => {
    this.visible = !this.visible
  }

  @observable home_wxacode = ''
  @observable merchant_wxacode = ''

  @action
  getWXACode = async page => {
    const { type } = this

    let apiName
    let params = { page }
    if (type == 1) {
      apiName = Api.WXACodeUrlShare(params)
    } else {
      apiName = Api.WXACodeUrl(params)
    }

    let { data, success } = await apiName
    if (success) {
      this[page + '_wxacode'] = data[page + '_wxacode']
      sessionStorage.setItem(page + '_wxacode', data[page + '_wxacode'])
    }
  }

  @observable shareVisible = false
  @observable vipVisible = false
  @observable visibleUpdate = false
  @observable type = 0
  @observable status = 0
  @action
  judgeOvertime = async () => {
    const { statusAuthorize } = this
    if (!statusAuthorize) {
      let {
        data: {
          merchant_weapp: { type, status, from_old_component, auth_status }
        }
      } = await Api.shopInfo()
      runInAction(() => {
        this.type = type
        this.status = status

        if (from_old_component == OLD_LITEAPP && auth_status == '1') {
          this.visibleUpdate = true
        } else {
          if (type == 1 && status == 2) {
            this.shareVisible = true
          }
          // if (type == 2 && status == 2) {
          //   this.vipVisible = true
          // }

          this.getWXACode('home')
          this.getWXACode('merchant')

          if (status == 1 && type == 2) {
            this.getVerList()
          }
        }
      })
    }
  }

  @action
  close = type => () => {
    this[type] = false
  }

  @action
  show = type => () => {
    this[type] = true
  }

  @observable audit_version = '0'
  @action
  getVerList = async () => {
    const { data, success } = await Api.auditInfo()
    if (success) {
      this.audit_version = data || {}
    }
  }

  @observable statistics = {}
  @action
  getStatistics = async () => {
    const { statusAuthorize } = this
    if (!statusAuthorize) {
      let { data } = await Api.stat()
      runInAction(() => {
        this.statistics = data
      })
    }
  }

  @action
  toPro = () => {
    hashHistory.push(SHOP_PRODUCTS_PATH)
  }

  @action
  toVip = () => {
    window.location.href = '#/localMerchant/marketingCenter/detail/65/2'
  }

  @observable downVisible = false
}
export default new Store()
